import { Text, View } from "@react-pdf/renderer";
import { borderStyleGray } from "../../reportingHelpers.jsx";
import React from "react";

const cellStyle = {
  border: borderStyleGray,
  borderLeft: "unset",
  borderTop: "unset",
  alignItems: "center",
};

const getResultTitle = (result, intl) => {
  switch (result) {
    case "conceded":
      return "X - " + intl.formatMessage({
        id: "reports.shootoutReport.goal",
        defaultMessage: "Goal",
      });
    case "saved":
      return "O - " + intl.formatMessage({
        id: "reports.shootoutReport.save",
        defaultMessage: "Save",
      });
    default:
      return "";
  }
};

const ScoringHeader = ({ intl }) => (
  <View style={{ flexDirection: "row", fontSize: 7, width: "100%" }}>
    <View style={{ ...cellStyle, flexBasis: "5%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.shootoutReport.shirtNumber",
          defaultMessage: "Shirt #",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "28%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.shootoutReport.attacker",
          defaultMessage: "Attacker",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "5%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.shootoutReport.goalkeeperNumber",
          defaultMessage: "GK #",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "9%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.shootoutReport.result",
          defaultMessage: "Result",
        })}
      </Text>
    </View>

    <View style={{ ...cellStyle, flexBasis: "6%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.shootoutReport.round",
          defaultMessage: "Round",
        })}
      </Text>
    </View>

    <View style={{ ...cellStyle, flexBasis: "5%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.shootoutReport.shirtNumber",
          defaultMessage: "Shirt #",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "28%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.shootoutReport.attacker",
          defaultMessage: "Attacker",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "5%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.shootoutReport.goalkeeperNumber",
          defaultMessage: "GK #",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "9%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.shootoutReport.result",
          defaultMessage: "Result",
        })}
      </Text>
    </View>

  </View>
);

const ScoringBody = ({ intl, data }) => {
  const result = [];
  for (let i = 0; i < Math.max(data.homeTeam.length, data.awayTeam.length); i++) {
    const homeTeam = data.homeTeam[i];
    const awayTeam = data.awayTeam[i];
    const round = i + 1;
    result.push(
      <View key={i} style={{ flexDirection: "row", fontSize: 10, width: "100%" }}>
        <View style={{ ...cellStyle, flexBasis: "5%" }}><Text>{homeTeam?.playerBib}</Text></View>
        <View style={{
          ...cellStyle,
          flexBasis: "28%",
          alignItems: "flex-start",
          paddingLeft: 2,
        }}>
          <Text>{homeTeam?.playerName}</Text>
        </View>
        <View style={{ ...cellStyle, flexBasis: "5%" }}><Text>{homeTeam?.goalKeeperBib}</Text></View>
        <View style={{ ...cellStyle, flexBasis: "9%" }}><Text>{getResultTitle(homeTeam?.result, intl)}</Text></View>

        <View style={{ ...cellStyle, flexBasis: "6%" }}><Text>{round}</Text></View>

        <View style={{ ...cellStyle, flexBasis: "5%" }}><Text>{awayTeam?.playerBib}</Text></View>
        <View style={{
          ...cellStyle,
          flexBasis: "28%",
          alignItems: "flex-start",
          paddingLeft: 2,
        }}>
          <Text>{awayTeam?.playerName}</Text>
        </View>
        <View style={{ ...cellStyle, flexBasis: "5%" }}><Text>{awayTeam?.goalKeeperBib}</Text></View>
        <View style={{ ...cellStyle, flexBasis: "9%" }}><Text>{getResultTitle(awayTeam?.result, intl)}</Text></View>
      </View>
    );
  }

  return result;
};

const TeamShootoutScoring = ({ intl, playByPlay, teams, homeTeamId, awayTeamId, }) => {
  const shootoutRows = playByPlay.filter(
    (e) => ["shootOutAttempt", "shootOutDefence"].includes(e.eventType)
      && ["made", "conceded", "missed", "saved"].includes(e.subType)
  );

  const scoringRowsData = {
    homeTeam: [],
    awayTeam: [],
  };
  for (let i = 0; i < shootoutRows.length; i += 2) {
    const shootOutAttempt = shootoutRows[i];
    const shootOutDefence = shootoutRows[i + 1];
    const player = teams[shootOutAttempt.entityId].players.find((p) => p.personId === shootOutAttempt.personId);
    const goalKeeper = teams[shootOutDefence.entityId].players.find((p) => p.personId === shootOutDefence.personId);

    const rowData = {
      playerBib: player.bib,
      playerName: player.personFullName,
      goalKeeperBib: goalKeeper.bib,
      result: shootOutDefence.subType,
    };

    if (shootOutAttempt.entityId === homeTeamId) {
      scoringRowsData.homeTeam.push(rowData);
    } else {
      scoringRowsData.awayTeam.push(rowData);
    }
  }

  return <View
    style={{
      flexDirection: "column",
      alignItems: "center",
      marginTop: 6,
      marginBottom: 6,
    }}
  >
    <Text style={{ fontSize: "12", fontWeight: "bold", textAlign: "center", marginBottom: 6 }}>
      {intl.formatMessage({
        id: "reports.shootoutReport.scoring",
        defaultMessage: "Scoring",
      })}
    </Text>
    <View
      style={{
        border: borderStyleGray,
        borderRight: "unset",
        borderBottom: "unset",
      }}
    >
      <ScoringHeader intl={intl}/>
      <ScoringBody intl={intl} data={scoringRowsData}/>
    </View>
  </View>;
};

export default TeamShootoutScoring;
